import { EmptyState } from '@app/components/base/EmptyState';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useIntl } from 'react-intl';
import { connectionsManageMessages as messages } from './connections-manage-messages';
import { PlatformConnectFactory } from './platforms/PlatformConnectFactory';

type Props = {
  platform: SocialPlatform;
};

/**
 * Empty state for the connections manage screen: shown when the client
 * has no connected accounts for the platform, with a connect CTA.
 */
export function ConnectionsEmptyState({ platform }: Props) {
  const { $t } = useIntl();

  return (
    <EmptyState
      message={$t(messages.emptyConnections)}
      help={$t(messages.emptyConnectionsHelp)}
      action={<PlatformConnectFactory platform={platform} />}
    />
  );
}
